import { render, staticRenderFns } from "./LikeDislikeComponent.vue?vue&type=template&id=25fee130&scoped=true"
import script from "./LikeDislikeComponent.vue?vue&type=script&lang=ts"
export * from "./LikeDislikeComponent.vue?vue&type=script&lang=ts"
import style0 from "./LikeDislikeComponent.vue?vue&type=style&index=0&id=25fee130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fee130",
  null
  
)

export default component.exports